import { Suspense, lazy } from "react";
// import "./App.css"; moved to index.css
import CacheBuster from "react-cache-buster";
import appversion from "../package.json";
 
import MainPage from "./components/MainPage/MainPage";

const CookieSetting = lazy(() => 
  new Promise(resolve => {
    setTimeout(() => resolve(import("cookiesetting-component")), 3000);
  }).then(module => ({ default: module.CookieSetting }))
);

function App() {
  const appVersion = appversion.version;
  return (
    <div className="bodyContainer">
      <CacheBuster
        currentVersion={appVersion}
        isEnabled={true}
        isVerboseMode={false}
        metaFileDirectory={process.env.PUBLIC_URL}
      >
        <>
          <MainPage />
          <Suspense fallback={null}>
            <CookieSetting
              privacyPolicyLink={process.env.REACT_APP_PRIVACY_POLICY_LINK}
              configUrl={process.env.REACT_APP_COOKIE_SETTING_JSON}
              analytics={process.env.REACT_APP_ANALYTICS_PATH}
            />
          </Suspense>
        </>
      </CacheBuster>
    </div>
  );
}
export default App;
